<template>
  <div>
    <div class="row">
      <h4 class="title is-4">В корзине:</h4>

      <p>В <a href="/shop/cart">корзине</a> {{numeral(totalCount).format('0,0')}} товаров
        на сумму {{numeral(totalPrice).format('0.00 $')}}</p>
    </div>

    <div class="row">
      <h4 class="title is-4">Проверьте ваши данные:</h4>
      <div>
        <p>Имя: {{customer.last_name}} {{customer.first_name}} {{customer.middle_name}}</p>
        <p>Телефон: {{customer.phone}}</p>
        <p>E-mail: {{customer.email}}</p>
      </div>
    </div>
  </div>
</template>

<script>
  import { numeral } from 'glonass/core/global'

  /**
   * Проверка заказа.
   */
  export default {
    name: 'check-step',

    props: {
      customer: {
        type: Object,
        required: true
      },

      cart: {
        type: Array,
        required: true
      },

      totalPrice: {
        type: Number,
        required: true
      },

      totalCount: {
        type: Number,
        required: true
      }
    },

    data () {
      return {
        numeral
      }
    },

    methods: {}
  }
</script>

<style scoped lang="scss">
  .row {
    margin-bottom: 1rem;
  }
</style>



// WEBPACK FOOTER //
// CheckStep.vue?738f6499